var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState } from 'react';
import AuthCache from '../utils/AuthCache';
import validator from 'validator';
import { ensureUserHasId, logOutOthers } from '../utils/authUtils';
import { confirmSignIn, signIn } from 'aws-amplify/auth';
import { IonicSafeString, useIonAlert, useIonLoading } from '@ionic/react';
import { useTranslation } from 'react-i18next';
var useSignIn = function (_a) {
    var isAdminPortal = _a.isAdminPortal, setErrorMessageKey = _a.setErrorMessageKey, onOtpRequestFailure = _a.onOtpRequestFailure, handleAdditionalSetup = _a.handleAdditionalSetup, handlePostSignIn = _a.handlePostSignIn;
    var _b = useState(''), email = _b[0], setEmail = _b[1];
    var _c = useState(false), hideRequestOtp = _c[0], setHideRequestOtp = _c[1];
    var _d = useState(''), otpConfirmation = _d[0], setOtpConfirmation = _d[1];
    var _e = useState(false), otpValidationFailed = _e[0], setOtpValidationFailed = _e[1];
    var _f = useIonLoading(), presentLoading = _f[0], dismissLoading = _f[1];
    var presentNewCodeAlert = useIonAlert()[0];
    var t = useTranslation().t;
    var validateEmail = function (emailAddress) {
        return validator.isEmail(emailAddress);
    };
    var requestOtp = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!email) {
                        return [2 /*return*/];
                    }
                    if (!validator.isEmail(email)) {
                        console.log('This looks like a bogus email', email);
                        //TODO: validation error?
                    }
                    setHideRequestOtp(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 6]);
                    // See https://docs.amplify.aws/react/build-a-backend/auth/switch-auth/#custom-authentication-flow
                    return [4 /*yield*/, signIn({
                            username: email.toLowerCase(),
                            options: {
                                authFlowType: 'CUSTOM_WITHOUT_SRP',
                            },
                        })];
                case 2:
                    // See https://docs.amplify.aws/react/build-a-backend/auth/switch-auth/#custom-authentication-flow
                    _a.sent();
                    return [3 /*break*/, 6];
                case 3:
                    error_1 = _a.sent();
                    if (!onOtpRequestFailure) return [3 /*break*/, 5];
                    return [4 /*yield*/, onOtpRequestFailure()];
                case 4:
                    _a.sent();
                    return [2 /*return*/];
                case 5:
                    if (error_1.code === 'UserNotFoundException' || error_1.code === 'NotAuthorizedException') {
                        //We do not hide the OTP screen so that we do not leak who is a user and who is not
                    }
                    else {
                        console.error('Sign in error', error_1);
                        setHideRequestOtp(false);
                        setErrorMessageKey(true);
                    }
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var requestNewOTP = function (e) {
        e.preventDefault();
        setOtpConfirmation('');
        setOtpValidationFailed(false);
        presentNewCodeAlert({
            header: t('newVerificationCodeSent.header'),
            message: new IonicSafeString(t('newVerificationCodeSent.message')),
            buttons: [t('button.acknowledge')],
        });
        requestOtp();
    };
    var verifyOtp = function () { return __awaiter(void 0, void 0, void 0, function () {
        var exception_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!email) {
                        return [2 /*return*/];
                    }
                    if (!otpConfirmation) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 11, 12, 14]);
                    return [4 /*yield*/, presentLoading()];
                case 2:
                    _a.sent(); //Wait for the loading spinner to present so we make sure it is there when trying to dismiss it
                    // See https://docs.amplify.aws/react/build-a-backend/auth/switch-auth/#custom-authentication-flow
                    return [4 /*yield*/, confirmSignIn({
                            challengeResponse: otpConfirmation,
                            options: {
                                clientMetadata: {
                                    "isAdminPortal": "".concat(isAdminPortal),
                                }
                            },
                        })];
                case 3:
                    // See https://docs.amplify.aws/react/build-a-backend/auth/switch-auth/#custom-authentication-flow
                    _a.sent();
                    return [4 /*yield*/, ensureUserHasId()];
                case 4:
                    _a.sent();
                    //await Auth.rememberDevice();// remember device was how we planned on implementing preventing budy logins
                    return [4 /*yield*/, AuthCache.refresh()];
                case 5:
                    //await Auth.rememberDevice();// remember device was how we planned on implementing preventing budy logins
                    _a.sent();
                    console.log('Logging out other users');
                    return [4 /*yield*/, logOutOthers()];
                case 6:
                    _a.sent();
                    if (!handleAdditionalSetup) return [3 /*break*/, 8];
                    return [4 /*yield*/, handleAdditionalSetup()];
                case 7:
                    _a.sent();
                    _a.label = 8;
                case 8:
                    if (!handlePostSignIn) return [3 /*break*/, 10];
                    return [4 /*yield*/, handlePostSignIn()];
                case 9:
                    _a.sent();
                    _a.label = 10;
                case 10: return [3 /*break*/, 14];
                case 11:
                    exception_1 = _a.sent();
                    console.error('Exception attempting to verify Otp', exception_1);
                    setOtpValidationFailed(true);
                    return [3 /*break*/, 14];
                case 12: return [4 /*yield*/, dismissLoading()];
                case 13:
                    _a.sent();
                    return [7 /*endfinally*/];
                case 14: return [2 /*return*/];
            }
        });
    }); };
    return {
        email: email,
        setEmail: setEmail,
        validateEmail: validateEmail,
        hideRequestOtp: hideRequestOtp,
        setHideRequestOtp: setHideRequestOtp,
        requestOtp: requestOtp,
        requestNewOTP: requestNewOTP,
        otpConfirmation: otpConfirmation,
        setOtpConfirmation: setOtpConfirmation,
        verifyOtp: verifyOtp,
        otpValidationFailed: otpValidationFailed,
    };
};
export default useSignIn;
